import Vue from "vue";
import VueRouter from "vue-router";

import psychologRegForm from "@/components/registration/registrationSteps/psychologRegForm";
import userRegForm from "@/components/registration/registrationSteps/patientRegForm";
import registration from "../views/registration";
import restore from "../views/restore";
import signIn from "@/views/auth/signIn";
import alternativeLogin from "@/views/auth/alternativeLogin";
import linkingLogin from "@/views/auth/linkingLogin";
import verify from "@/views/auth/verify";
import authCallback from "@/views/auth/authCallback";
import emailRegistration from "../views/auth/emailRegistration";
import authLayout from "@/components/registration/layouts/authLayout";
import pageNotFound from "@/views/auth/pageNotFound";
import registrationLayout from "../components/registration/layouts/registrationLayout";

import blog from "@/views/dashboard/blog";
import psychologists from "../views/dashboard/admin/psychologists";
const Specialization = () =>
  import("../views/dashboard/psychologist/Specialization");
const dashboardLayout = () => import("../components/dashboard/dashboardLayout");
const dashboard = () => import("../views/dashboard/dashboard");
const help = () => import("../views/dashboard/help");
const settings = () => import("../views/dashboard/settings");
const psychologist = () => import("../views/dashboard/patient/psychologists/Index");
const psychologistShow = () => import("../views/dashboard/patient/psychologists/Show");
const favorites = () => import("../views/dashboard/patient/favorites");
const psychologistForum = () => import("../views/dashboard/psychologist/Forum");
const adminForum = () => import("../views/dashboard/admin/forum");
const myQuestions = () => import("../views/dashboard/patient/myQuestions");
const myTests = () => import("../views/dashboard/patient/myTests");
const chat = () => import("../views/dashboard/chat");
const adminTests = () => import("../views/dashboard/admin/tests");
const psychologistGuide = () => import("../views/dashboard/psychologist/Guide");
const adminGuide = () => import("../views/dashboard/admin/guide");
const adminAiAgent = () => import("../views/dashboard/admin/aiAgent");
const adminCrm = () => import("../views/dashboard/admin/crm");
/* const payment = () => import("../views/dashboard/patient/payment"); */
const Schedule = () => import("../views/dashboard/psychologist/Schedule");

import store from "@/store";
import { isSubscriptionLocked, isLockedPath } from "@/utils/subscriptionLock";
import redactors from "../views/dashboard/admin/redactors";
import categories from "../views/dashboard/admin/categories";
import events from "../views/dashboard/admin/events";
import postComponent from "../components/dashboard/postComponent";

Vue.use(VueRouter);

const routes = [
  {
    path: "/registration",
    component: registration,
  },
  {
    path: "/restore",
    component: restore,
  },
  {
    path: "/auth-callback",
    component: authCallback,
  },
  {
    // client joins the psychologist's video room by link, no account needed
    path: "/room/:token",
    name: "guestRoom",
    component: () => import("../views/room/GuestRoom"),
  },
  {
    path: "/linking-login",
    name: "linkingLogin",
    component: linkingLogin,
    meta: {
      isPrivate: true,
      roles: ["admin", "redactor", "psychologist", "patient"],
    },
  },
  {
    path: "/help",
    name: "help",
    component: help,
    meta: {
      isPrivate: true,
      roles: ["admin", "redactor", "psychologist", "patient"],
    },
  },
  {
    path: "/old-auth",
    component: authLayout,
    children: [
      {
        path: "",
        name: "oldAuth",
        component: alternativeLogin,
        meta: {
          option: "auth",
          authAndRegGroup: true,
          isPrivate: false,
          title: "$vuetify.main.route.enter",
          url: "/old-auth/verify",
        },
      },
      {
        path: "verify",
        component: verify,
        meta: {
          option: "auth",
          authAndRegGroup: true,
          payloadOption: "phone",
          url: "/dashboard/main",
          isPrivate: false,
        },
      },
    ],
  },
  {
    path: "/auth",
    component: authLayout,
    children: [
      {
        path: "",
        name: "auth",
        component: signIn,
        meta: {
          option: "auth",
          authAndRegGroup: true,
          isPrivate: false,
          title: "$vuetify.main.route.enter",
          url: "/auth/verify",
        },
      },
      {
        path: "verify",
        component: verify,
        meta: {
          option: "auth",
          authAndRegGroup: true,
          payloadOption: "phone",
          url: "/dashboard/main",
          isPrivate: false,
        },
      },
    ],
  },
  {
    path: "/patientRegForm",
    component: registrationLayout,
    meta: {
      isPrivate: false,
    },
    children: [
      {
        path: "",
        component: signIn,
        meta: {
          authAndRegGroup: true,
          url: "/patientRegForm/verify",
          title: "$vuetify.main.route.registration",
          isPrivate: false,
          option: "patientReg",
        },
      },
      {
        path: "verify",
        component: verify,
        meta: {
          authAndRegGroup: true,
          url: "/signUp",
          isPrivate: false,
          option: "patientReg",
          preRole: "patient",
          payloadOption: "phone",
        },
      },
      {
        path: "/signUp",
        component: userRegForm,
        meta: {
          authAndRegGroup: true,
          title: "$vuetify.main.route.registration",
          isPrivate: false,
        },
      },
    ],
  },
  {
    path: "/psychologistRegForm",
    component: registrationLayout,
    meta: {
      isPrivate: false,
    },
    children: [
      {
        path: "",
        component: signIn,
        meta: {
          authAndRegGroup: true,
          title: "$vuetify.main.route.registration",
          url: "/psychologistRegForm/verify",
          isPrivate: false,
          option: "psychReg",
        },
      },
      {
        path: "verify",
        component: verify,
        meta: {
          authAndRegGroup: true,
          url: "/psychologistRegForm/email",
          isPrivate: false,
          option: "psychReg",
          payloadOption: "phone",
        },
      },
      {
        path: "email",
        component: emailRegistration,
        meta: {
          authAndRegGroup: true,
          isPrivate: false,
          url: "/psychologistRegForm/email/verify",
          option: "sendPsychRegEmail",
        },
      },
      {
        path: "email/verify",
        component: verify,
        meta: {
          authAndRegGroup: true,
          url: "/form",
          isPrivate: false,
          option: "verifyEmailCode",
          payloadOption: "email",
        },
      },
      {
        path: "/form",
        name: "psychologRegForm",
        component: psychologRegForm,
        meta: {
          authAndRegGroup: true,
          isPrivate: false,
        },
      },
    ],
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: dashboardLayout,
    children: [
      {
        path: "main",
        name: "main",
        component: dashboard,
        meta: {
          isPrivate: true,
          roles: ["patient", "psychologist"],
        },
      },
      {
        path: "settings",
        component: settings,
        meta: {
          isPrivate: true,
          roles: ["patient", "psychologist"],
        },
      },
      {
        path: "psychologist",
        name: 'psychologists.index',
        component: psychologist,
        meta: {
          isPrivate: true,
          roles: ["patient"],
        },
      },
      {
        path: "favorites",
        name: "favorites",
        component: favorites,
        meta: {
          isPrivate: true,
          roles: ["patient"],
        },
      },
      {
        path: '/psychologist/:profile_id',
        name: 'psychologists.show',
        component: psychologistShow,
        meta: {
          isPrivate: true,
          roles: ["patient"],
        },
      },
      /* {
        path: "payment",
        component: payment,
        meta: {
          isPrivate: true,
          roles: ["patient"],
        },
      }, */
      {
        path: "Specialization",
        component: Specialization,
        meta: {
          isPrivate: true,
          roles: ["psychologist"],
        },
      },
      {
        path: "Schedule",
        component: Schedule,
        meta: {
          isPrivate: true,
          roles: ["psychologist"],
        },
      },
      {
        path: "blog",
        name: "blog",
        component: blog,
        meta: {
          roles: ["admin", "redactor", "psychologist", "patient"],
          isPrivate: true,
        },
      },
      {
        path: "/blog/posts/:slug",
        name: "blog-post",
        component: postComponent,
        meta: {
          roles: ["psychologist", "patient"],
          isPrivate: true,
        },
      },
      {
        path: "forum",
        name: "forum",
        component: psychologistForum,
        meta: {
          isPrivate: true,
          roles: ["psychologist"],
        },
      },
      {
        path: "chat",
        name: "chat",
        component: chat,
        meta: {
          isPrivate: true,
          roles: ["patient", "psychologist"],
        },
      },
      {
        path: "my-tests",
        name: "myTests",
        component: myTests,
        meta: {
          isPrivate: true,
          roles: ["patient"],
        },
      },
      {
        path: "tests-admin",
        name: "testsAdmin",
        component: adminTests,
        meta: {
          isPrivate: true,
          roles: ["admin", "redactor"],
        },
      },
      {
        path: "my-questions",
        name: "myQuestions",
        component: myQuestions,
        meta: {
          isPrivate: true,
          roles: ["patient"],
        },
      },
      {
        path: "guide",
        name: "guide",
        component: psychologistGuide,
        meta: {
          isPrivate: true,
          roles: ["psychologist"],
        },
      },
      {
        path: "guide-admin",
        name: "guideAdmin",
        component: adminGuide,
        meta: {
          isPrivate: true,
          roles: ["admin"],
        },
      },
      {
        path: "crm",
        name: "crmAdmin",
        component: adminCrm,
        meta: {
          isPrivate: true,
          roles: ["admin"],
        },
      },
      {
        path: "ai-agent",
        name: "aiAgentAdmin",
        component: adminAiAgent,
        meta: {
          isPrivate: true,
          roles: ["admin"],
        },
      },
      {
        path: "forum-admin",
        name: "forumAdmin",
        component: adminForum,
        meta: {
          isPrivate: true,
          roles: ["admin"],
        },
      },
      {
        path: "events",
        name: "events",
        component: events,
        meta: {
          isPrivate: true,
          roles: ["admin", "redactor"],
        },
      },
      {
        path: "categories",
        component: categories,
        meta: {
          isPrivate: true,
          roles: ["admin", "redactor"],
        },
      },
      {
        path: "redactors",
        name: "redactors",
        component: redactors,
        meta: {
          isPrivate: true,
          roles: ["admin"],
        },
      },
      {
        path: "psychologists",
        component: psychologists,
        meta: {
          isPrivate: true,
          roles: ["admin"],
        },
      },
    ],
  },
  {
    path: "*",
    component: pageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

function syncQueryState(to) {
  if (to.query.set_consultation_type) {
    const consultationType = parseInt(to.query.set_consultation_type, 10);

    if (!Number.isNaN(consultationType)) {
      store.commit("consultation_type/SET_TYPE", consultationType);
    }
  }

  if (to.query.chosen_psychologist) {
    store.commit(
      "user/SET_CHOSEN_PSYCHOLOGIST_ID",
      to.query.chosen_psychologist
    );
  }

  if (to.query.set_calendar_id) {
    store.commit(
      "user/SET_CHOSEN_CALENDAR_ID",
      to.query.set_calendar_id
    );
  }
}

// users who signed in by SMS and have no Google/Apple yet must link one
// (all of them when the backend asks for it, otherwise only non-UA numbers as before)
export function needsLinkingLogin(to, authParam, user) {
  const exceptPaths = ["/linking-login", "/restore", "/auth-callback"];
  if (!authParam.isAuth || exceptPaths.includes(to.path) || to.path.startsWith("/room/")) {
    return false;
  }
  if (authParam.userRole === "admin" || authParam.userRole === "redactor") {
    return false;
  }
  if (user.login_provider !== undefined && user.login_provider !== null) {
    return false;
  }
  return store.getters["settings/requireProviderAfterSms"] || user.phone_country_code !== "UA";
}

router.beforeEach((to, from, next) => {
  syncQueryState(to);

  if (to.path === "/auth/verify/" && from.path !== "/auth/") {
    return next({ name: "auth" });
  }

  let authParam = store.getters["user/getAuthParam"];
  let user = store.getters["user/getUser"];

  if (needsLinkingLogin(to, authParam, user)) {
    return next({ name: "linkingLogin" });
  }

  // the client's cabinet has no "Консультація" tab any more: it opens on the settings
  if (to.name === "main" && authParam.isAuth && authParam.userRole === "patient") {
    return next({ path: "/dashboard/settings", query: to.query });
  }
  
  // unpaid psychologist: settings, specialization, schedule are closed, the cabinet explains how to activate
  if (authParam.isAuth && isLockedPath(to.path) && isSubscriptionLocked(user)) {
    if (router.app) router.app.$emit("subscription-locked");
    return next(from.matched.length ? false : { name: "main" });
  }

  if (
    to.path === "/linking-login" &&
    authParam.isAuth &&
    (user.login_provider !== undefined && user.login_provider !== null)
  ) {
    if(authParam.userRole === "patient" || authParam.userRole === "psychologist") {
      return next({ name: "main" });
    } else {
      return next({ name: "blog" });
    }
  }

  if (
    to.path === "/" &&
    authParam.isAuth &&
    (authParam.userRole === "patient" || authParam.userRole === "psychologist")
  ) {
    next({ name: "main" });
  } else if (
    to.path === "/" &&
    authParam.isAuth &&
    (authParam.userRole === "admin" || authParam.userRole === "redactor")
  ) {
    next({ name: "blog" });
  } else if (to.path === "/" && !authParam.isAuth) {
    next({ name: "auth" });
  }
  if (to.matched.some((record) => record.meta.isPrivate)) {
    if (authParam.isAuth && to.meta.roles.includes(authParam.userRole)) {
      next();
    } else {
      store.commit("user/SET_LOGOUT");
      next({ 
        name: "auth",
        query: { redirect: to.fullPath }
      });
    }
  }
  if (to.matched.some((record) => record.meta.authAndRegGroup)) {
    if (
      (authParam.isAuth && authParam.userRole === "patient") ||
      authParam.userRole === "psychologist"
    ) {
      next({ name: "main" });
    } else if (
      (authParam.isAuth && authParam.userRole === "admin") ||
      authParam.userRole === "redactor"
    ) {
      next({ name: "blog" });
    } else {
      next();
    }
  }

  return next();
});

export default router;
